import { createContext } from "react";

import type { ScreenSize } from "common/styles/mediaQueries/types";

export const ViewportContext = createContext<ScreenSize | undefined>(undefined);
